const FAILED = 'FAILED';
const STARTED = 'STARTED';
const SUCCEEDED = 'SUCCEEDED';
const UNINITIALIZED = 'UNINITIALIZED';
export const RequestStates = {
  FAILED,
  STARTED,
  SUCCEEDED,
  UNINITIALIZED
};